import React, { useState, useEffect, useContext } from 'react';
import { TRCTextArea } from '../../lib/atoms';
import { ComponentProps } from '../../organisms/RFPComponent/RFPComponent.types';
import clsx from 'clsx';
import { StyledEventInformationDiv } from './index.styles';
import { serverData } from '../../organisms/RFPComponent/context';
import { iprops } from './index.types';
import { CheckBox, InputTextField, RadioButton } from '@marriott/mi-ui-library';

export const EventInformation: React.FC<iprops> = (props: iprops) => {
  const { jsonContent }: ComponentProps = useContext(serverData);
  const pageType = jsonContent?.['instanceType'];
  const labels = jsonContent?.['instance']?.labels ?? {};
  const eventInformation = jsonContent?.['instance']?.eventInformation?.fieldSet
    ? [...jsonContent['instance']['eventInformation']['fieldSet']]
    : [];
  const [eventNameValue, setEventNameValue] = useState('');
  const [eventAttendees, setEventAttendeesValue] = useState('');
  const [eventPurpose, setEventPurposeValue] = useState('');
  const [roomCountOption, setRoomCountOption] = useState('');
  const [eventType, setEventType] = useState([] as (string | undefined)[]);
  const [eventGuestRooms, setEventGuestRooms] = useState('');

  const onClear = (flag: boolean) => {
    if (flag) {
      setEventNameValue('');
      setEventAttendeesValue('');
      setEventPurposeValue('');
      setRoomCountOption('');
      setEventType([]);
      setEventGuestRooms('');
      const roomCountOptionArr = Array.from(
        document.getElementsByClassName('roomCountOption') as HTMLCollectionOf<HTMLElement>
      )[0]?.children;
      if (roomCountOptionArr[0]?.children[1] || roomCountOptionArr[1]?.children[0]) {
        (roomCountOptionArr[0]?.children[0] as HTMLInputElement).checked = false;
        (roomCountOptionArr[1]?.children[0] as HTMLInputElement).checked = false;
      }
      const eventTypeArr = Array.from(document.getElementsByClassName('eventType') as HTMLCollectionOf<HTMLElement>)[0]
        ?.children;
      for (let i = 0; i < eventTypeArr?.length; i++) {
        if (eventTypeArr[i]?.children[1]) {
          (eventTypeArr[i]?.children[0] as HTMLInputElement).checked = false;
        }
      }
    }
  };

  const onChangeEventType = (event: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent | undefined) => {
    let temp = [];
    let updatedArr = [];
    const target = event?.target as HTMLInputElement;
    const value = event && target?.value;
    let checked = target?.checked;
    if (event && 'key' in event && (event?.key === 'Enter' || event?.keyCode === 13)) {
      checked = !checked;
    }
    const meetOrWed = pageType === 'meetings' ? 4 : 0;
    if (checked) {
      setEventType(oldArray => [...oldArray, value]);
      updatedArr = [...eventType, value];
    } else {
      temp = eventType.filter(e => e !== value);
      setEventType(temp);
      updatedArr = [...temp];
    }
    props.onDataChange({
      key: eventInformation[meetOrWed]?.name,
      value: updatedArr,
    });
  };

  useEffect(() => {
    onClear(props.onClear);
  }, [props.data, props.onClear]);

  const changeAndKeyBoardEvent = (
    event: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent | undefined,
    index1: number,
    index2: number
  ) => {
    const target = event?.target as HTMLInputElement;
    event && setRoomCountOption(target?.value);
    if (target?.value === (labels?.noLabel ?? 'No')) {
      setEventGuestRooms('');
      props.onDataChange({
        key: eventInformation[index1]?.name,
        value: '',
      });
    }
    props.onDataChange({
      key: eventInformation[index2]?.name,
      value: target?.value,
    });
  };

  return (
    <StyledEventInformationDiv data-component-name="m-trc-EventInformation" data-testid="trc-EventInformation">
      <p className="mb-md-5 pb-2 pb-md-3 pt-5 t-title-alt-s t-rc-italic">
        {props.index}.{jsonContent?.['instance']?.eventInformation?.name}
      </p>
      <div className="eventInformation offset-xl-2 row d-flex flex-wrap pb-md-5">
        {pageType === 'meetings' && (
          <>
            <InputTextField
              className={`m-input-field col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0 rfp-${eventInformation[0]?.name}`}
              label={`${eventInformation[0]?.fieldName}`}
              showErrorMessage={props?.data[0]?.isError}
              setErrorHtml={props?.data[0]?.isError}
              messageToShow={eventInformation[0]?.errorMessage}
              isClickEnabled={true}
              mandatory={eventInformation[0]?.mandatory}
              assignInputValue={eventNameValue ? true : false}
              inputValue={eventNameValue}
              messageClass={'error-text t-font-xs pt-1'}
              isBlurOn={false}
              placeHolderText={eventInformation[0]?.placeholder}
              disabled={props.submitted}
              getInputValue={(value: string) => {
                setEventNameValue(value);
                props.onDataChange({
                  key: eventInformation[0]?.name,
                  value: value,
                });
              }}
            />
            <InputTextField
              className={`m-input-field col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0 rfp-${eventInformation[2]?.name}`}
              type="number"
              label={`${eventInformation[2]?.fieldName}`}
              showErrorMessage={props?.data[1]?.isError}
              setErrorHtml={props?.data[1]?.isError}
              messageToShow={eventInformation[2]?.errorMessage}
              isClickEnabled={true}
              mandatory={eventInformation[2]?.mandatory}
              assignInputValue={eventAttendees ? true : false}
              inputValue={eventAttendees}
              messageClass={'error-text t-font-xs pt-1'}
              isBlurOn={false}
              placeHolderText={eventInformation[2]?.placeholder}
              disabled={props.submitted}
              getInputValue={(value: string) => {
                setEventAttendeesValue(value);
                props.onDataChange({
                  key: eventInformation[2]?.name,
                  value: value,
                });
              }}
            />
            <TRCTextArea
              textareaId={eventInformation[1]?.name}
              textareaName={eventInformation[1]?.name}
              textareaLabel={`${eventInformation[1]?.fieldName}`}
              textareaLabelClassName=""
              className="col-12 col-xl-12 col-md-8 mt-xl-4 mb-4 mb-md-5 mb-xl-0"
              innerClassName="textAreaInput t-rc-alt-border-color"
              placeholder={eventInformation[1]?.placeholder}
              mandatory={eventInformation[1]?.mandatory}
              isError={props?.data[2]?.isError}
              errorMessage={eventInformation[1]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={eventPurpose}
              disabled={props.submitted}
              onChange={(value: string) => {
                setEventPurposeValue(value);
                props.onDataChange({
                  key: eventInformation[1]?.name,
                  value: value,
                });
              }}
            />

            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 m-0 mb-4 mb-md-5 mb-xl-3">{`${
              eventInformation[3]?.fieldName
            }
            ${eventInformation[3]?.mandatory ? '*' : ''}`}</p>

            <div className="roomCountOption d-flex col-12 col-xl-12 col-md-8">
              {eventInformation[3]?.inputOptions?.map((item: { dependency: Array<string>; option: string }) => {
                return (
                  <RadioButton
                    radiobuttonId={`${eventInformation[3]?.name}_${item['option']}`}
                    radiobuttonName={eventInformation[3]?.name + item['option']}
                    radiobuttonLabel={item['option']}
                    aria-label={`${eventInformation[3]?.name}_${item['option']}`}
                    ariaLabelForLink={`${eventInformation[3]?.name}_${item['option']}`}
                    disabled={props.submitted}
                    className={clsx(
                      'm-radio-button-sm',
                      'pr-4',
                      `rfp-${eventInformation[3]?.name}`,
                      props?.data[3]?.isError ? 'error' : ''
                    )}
                    labelClassName="t-font-m"
                    checked={item['option'] === props?.data[3]?.value}
                    onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                      changeAndKeyBoardEvent(event, 4, 3);
                    }}
                    onKeyDown={(event: React.KeyboardEvent) => {
                      if (event?.key === 'Enter' || event?.keyCode === 13) {
                        changeAndKeyBoardEvent(event, 4, 3);
                      }
                    }}
                    value={item['option']}
                    setTabIndex={-1}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8  mb-4 mb-md-5 mb-xl-4',
                props?.data[3]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventInformation[3]?.errorMessage}
            </div>

            {roomCountOption === (labels?.yesLabel ?? 'Yes') && (
              <InputTextField
                className={`m-input-field col-12 col-xl-6 col-md-8 mt-xl-4 mt-4 mt-md-5 rfp-${eventInformation[4]?.name}`}
                type="number"
                label={`${eventInformation[4]?.fieldName}`}
                showErrorMessage={props?.data[4]?.isError}
                setErrorHtml={props?.data[4]?.isError}
                messageToShow={eventInformation[4]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventInformation[4]?.mandatory}
                assignInputValue={eventGuestRooms ? true : false}
                inputValue={eventGuestRooms}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventInformation[4]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setEventGuestRooms(value);
                  props.onDataChange({
                    key: eventInformation[4]?.name,
                    value: value,
                  });
                }}
              />
            )}
          </>
        )}
        {pageType === 'weddings' && (
          <>
            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8  m-0 mb-xl-3 mb-4 mb-md-5">
              {`${eventInformation[0]?.fieldName}${eventInformation[0]?.mandatory ? '*' : ''}`}
            </p>
            <div className={clsx('eventType d-flex col-12 col-xl-12 col-md-8 pb-xl-4 mb-4 mb-md-5 mb-xl-0')}>
              {eventInformation[0]?.inputOptions?.map((item: { id: string; value: string }) => {
                return (
                  <CheckBox
                    checkboxId={`${item['value']}_${item['id']}`}
                    checkboxName={item['value']}
                    className={clsx(
                      'checkbox pr-xl-5 mr-2 mr-md-0',
                      `rfp-${item['value']}`,
                      props?.data[5]?.isError ? 'error' : ''
                    )}
                    onChange={(e: React.ChangeEvent<HTMLInputElement> | undefined) => onChangeEventType(e)}
                    onKeyDown={(e: React.KeyboardEvent) => onChangeEventType(e)}
                    checkboxLabel={item['value']}
                    value={item['value']}
                    disabled={props.submitted}
                    checked={((props?.data[5]?.value as Array<string>) ?? []).includes(item['value'])}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8 mb-4 mb-md-5 mb-xl-0',
                props?.data[5]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventInformation[0]?.errorMessage}
            </div>
            <InputTextField
              className={`m-input-field col-12 col-xl-6 col-md-8 mb-xl-3 mb-4 mb-md-5 rfp-${eventInformation[1]?.name}`}
              type="number"
              label={`${eventInformation[1]?.fieldName}`}
              showErrorMessage={props?.data[1]?.isError}
              setErrorHtml={props?.data[1]?.isError}
              messageToShow={eventInformation[1]?.errorMessage}
              isClickEnabled={true}
              mandatory={eventInformation[1]?.mandatory}
              assignInputValue={eventAttendees ? true : false}
              inputValue={eventAttendees}
              messageClass={'error-text t-font-xs pt-1'}
              isBlurOn={false}
              placeHolderText={eventInformation[1]?.placeholder}
              disabled={props.submitted}
              getInputValue={(value: string) => {
                setEventAttendeesValue(value);
                props.onDataChange({
                  key: eventInformation[1]?.name,
                  value: value,
                });
              }}
            />

            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 m-0  mb-4 mb-md-5 mb-xl-3">{`${
              eventInformation[2]?.fieldName
            }
            ${eventInformation[2]?.mandatory ? '*' : ''}`}</p>

            <div className="roomCountOption d-flex col-12 col-xl-12 col-md-8">
              {eventInformation[2]?.inputOptions?.map((item: { dependency: Array<string>; option: string }) => {
                return (
                  <RadioButton
                    radiobuttonId={`${eventInformation[2]?.name}_${item['option']}`}
                    radiobuttonName={eventInformation[2]?.name + item['option']}
                    radiobuttonLabel={item['option']}
                    aria-label={`${eventInformation[3]?.name}_${item['option']}`}
                    ariaLabelForLink={`${eventInformation[3]?.name}_${item['option']}`}
                    disabled={props.submitted}
                    className={clsx(
                      'm-radio-button-sm',
                      'pr-4',
                      `rfp-${eventInformation[2]?.name}`,
                      props?.data[3]?.isError ? 'error' : ''
                    )}
                    labelClassName="t-font-m"
                    checked={item['option'] === props?.data[3]?.value}
                    onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                      changeAndKeyBoardEvent(event, 3, 2);
                    }}
                    onKeyDown={(event: React.KeyboardEvent) => {
                      if (event?.key === 'Enter' || event?.keyCode === 13) {
                        changeAndKeyBoardEvent(event, 3, 2);
                      }
                    }}
                    value={item['option']}
                    setTabIndex={-1}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8 mb-4 mb-md-4',
                props?.data[3]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventInformation[2]?.errorMessage}
            </div>

            {roomCountOption === (labels?.yesLabel ?? 'Yes') && (
              <InputTextField
                className={`m-input-field col-12 col-xl-6 col-md-8 mb-xl-3 mb-4 mb-md-5 mt-4 mt-md-5 rfp-${eventInformation[3]?.name}`}
                type="number"
                label={`${eventInformation[3]?.fieldName}`}
                showErrorMessage={props?.data[4]?.isError}
                setErrorHtml={props?.data[4]?.isError}
                messageToShow={eventInformation[3]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventInformation[3]?.mandatory}
                assignInputValue={eventGuestRooms ? true : false}
                inputValue={eventGuestRooms}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventInformation[3]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setEventGuestRooms(value);
                  props.onDataChange({
                    key: eventInformation[3]?.name,
                    value: value,
                  });
                }}
              />
            )}
          </>
        )}
      </div>
    </StyledEventInformationDiv>
  );
};
